import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClientHelperService } from "../http-client-helper.service";
import { CreateBrandRequest, DsrBrandBase, DsrMultiBrandShallowResponse, DsrBrandDetails } from "../models/dsr/dsr-multi-brand.interface";
import { JsonPatchDocument } from "src/app/shared/models/json-patch.interface";

@Injectable({
  	providedIn: 'root'
})
export class ApiClientDsrMultiBrandService {

	private readonly dsrController = 'dsr';
	private readonly brandController = 'brand';
	private readonly version = 'v1';

    constructor(
        private httpClientHelper: HttpClientHelperService
    ) { }

	getBrandsShallow(): Observable<DsrMultiBrandShallowResponse> {
		return this.httpClientHelper.invokeGetAuth<DsrMultiBrandShallowResponse>(`${this.dsrController}/${this.version}/${this.brandController}/list`);
	}

	createBrand(brandData: CreateBrandRequest): Observable<DsrBrandBase> {
		return this.httpClientHelper.invokePostAuth<DsrBrandBase>(`${this.dsrController}/${this.version}/${this.brandController}`, brandData);
	}
	
	getBrandDetails(brandId: string): Observable<DsrBrandDetails> {
		return this.httpClientHelper.invokeGetAuth<DsrBrandDetails>(`${this.dsrController}/${this.version}/${this.brandController}/${brandId}`);
	}

	patchBrand(brandId: string, patch: JsonPatchDocument): Observable<DsrBrandBase> {
		return this.httpClientHelper.invokePatchAuth<DsrBrandBase>(`${this.dsrController}/${this.version}/${this.brandController}/${brandId}`, patch);
	}
	
	uploadBrandLogo(brandId: string, file: File): Observable<{ url: string }> {
		const formData = new FormData();
		formData.append('file', file, file.name);
		return this.httpClientHelper.invokePostAuth<{ url: string }>(
			`${this.dsrController}/${this.version}/${this.brandController}/${brandId}/logo`,
			formData
		);
	}
}